<script setup>
import { ref, onMounted, watch, defineExpose, reactive, defineEmits } from "vue"
import i18n from "@/i18n"
import { dateFormat1 } from "@/utils/common.js";
import { useRouter, useRoute } from "vue-router";
import usetablePageNation from "@/utils/hooks/usetablePageNation" //分页hooks
import useMessage from "@/utils/hooks/useMessage" //信息hooks
import Swal from "sweetalert2";
// import QRCode from "qrcode";
import { deleteProduct } from "@/service"
import { getBusinessProductsList } from "@/service/apiList/businessProduct"
import PreviewImg from "@/components/common/PreviewImg";
import { getLangValue, makeQrCode } from "@/utils/common"; //获取后端语言
const emits = defineEmits(['updateTabData', 'viewTabData'])
const tableInfo = ref([
    // {
    //     id: '66b48e7202285ec2de14e835',
    //     't_name':'U240719094137625000',
    //     name: 'dwqqq',
    //     hscode: 'dwqwqq',
    //     description: 'dwqqqqqqdwqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq',
    //     price: 4343,
    //     color: '黑色',
    //     inventory: 500,
    //     pid: 'dwqqdqdqdwqqqqqqqq',
    //     create_time: '2024-08-20',
    //     place_of_incorporation: 'dwqdwqdqdwqqqqqqqqqqqqqqqqqqqqqqqqq',
    // }
])
const router = useRouter()
const route = useRoute()
const activeImageSrc = ref('')
const showPreviewImg = ref(false)
const loading = ref(false)
const table_head = ref([
    { label: getLangValue('business-product', "tableHeader1"), width: '10%', },
    { label: 'HS Code', width: '10%', },
    { label: getLangValue("attribute.description"), width: '10%', },
    { label: getLangValue('business-product', "tableHeader2"), width: '10%', },
    { label: getLangValue('product-template', "origin"), width: '10%', },
    { label: getLangValue('product-management', "color"), width: '10%', },
    { label: getLangValue('product-template', "inventory"), width: '10%', },
    { label: getLangValue('product-template', "price"), width: '10%', sortable: false },
    { label: getLangValue('product-management', "code_pid_gtin"), width: '10%', },
    { label: getLangValue("base.operation"), width: '10%', },
])
const pageSizeOption = [10, 20, 30, 40, 50]

const { total, currentPage, pageSize, pageOption } = usetablePageNation()
const { alertInfo, openAlert, formValidataAlert } = useMessage()

const searchInfo = reactive({
    type: route.query.search_type || 0, //类型
    keyword: '',
    date: null,
    company_type: '',
    company_register_address: '',
    order_by: 'desc'
})
const handler = (type, info) => {
    //按钮处理
    let url;
    switch (type) {
        // 根据状态显示信息   未审批直接到审批页面    未通过  已通过到详情页面
        case 'view':
            url = router.resolve({
                path: '/business_products_management_detail',
                query: {
                    id: info.id,
                    t_name: info.organization.table_name,
                    search_type: searchInfo.type,
                    database_id: info.database_id
                }
            }).href;
            window.open(url, '_blank')
            break;
        case 'delete':
            deleteData(info)
            break;
    }
}

const deleteData = async (info) => {
    const { id } = info;
    Swal.fire({
        title: getLangValue('business-product', "delete_alert_title"),
        text: getLangValue('business-product', "delete_alert_info"),
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#f46a6a",
        confirmButtonColor: "#34c38f",
        confirmButtonText: getLangValue("base.done"),
        cancelButtonText: getLangValue("base.cancel"),
    }).then(async (result) => {
        if (result.isConfirmed) {
            // console.log(id)
            //延迟2s操作
            let resp = await deleteProduct(id);
            if (resp) {
                openAlert({
                    variant: resp.code == 1 ? "danger" : 'success',
                    content: resp.code == 1 ? resp.message : getLangValue("base.delete_success"),
                });
                //  更新
                getDataList();
            }
        }
    });
}

const getDataList = async () => {
    // let arr = searchInfo.date == null || !searchInfo.date ? [] : searchInfo.date.replaceAll(' ', '').split('to')
    //获取数据
    let params = {
        page: currentPage.value - 1,
        limit: pageSize.value,
        keyword: searchInfo.keyword,
        status: searchInfo.type, //类型
        submission_date: searchInfo.date == null || !searchInfo.date ? "" : JSON.stringify(searchInfo.date),
        // company_type: searchInfo.company_type,
        // place_of_incorporation: searchInfo.company_register_address,
        order_by: searchInfo.order_by,
        sort_field: 'create_time',
    }
    // tableInfo.value = mockData.filter(item => item.status == params.type)
    let xx = true
    if (xx) {
        loading.value = true
        const resp = await getBusinessProductsList(params);
        loading.value = false
        if (resp.code == 0) {
            tableInfo.value = resp.payload.data;
            tableInfo.value.forEach(async (item) => {
                if (item.pid) {
                    const reps = await makeQrCode({ type: 2, id: item.id })
                    if (reps) {
                        item.qrcodeImgUrl = reps
                    }
                }
            })
            if (searchInfo.type == 0) {
                total.value = resp.payload.wait_review_total
            } else if (searchInfo.type == 3) {
                total.value = resp.payload.review_failed_total
            } else if (searchInfo.type == 1) {
                total.value = resp.payload.testing_success_total
            } else {
                total.value = resp.payload.certification_success_total
            }
            emits('updateTabData', resp.payload)
        } else {
            openAlert({
                variant: "danger",
                content: resp.message,
            });
        }
    }
}

const showImageCode = (url) => {
    /**查看二维码大图 */
    activeImageSrc.value = url;
    if (activeImageSrc.value == "") {
        return;
    }
    showPreviewImg.value = true;
}

const sort = (type) => {
    searchInfo.order_by = type
}


watch(pageSize, () => {
    currentPage.value = 1;
    getDataList()
})


watch(currentPage, () => {
    getDataList();
})

watch(searchInfo, () => {
    currentPage.value = 1;
    getDataList();
}, { deep: true })


onMounted(() => {
    getDataList()
})
//弹出
defineExpose({
    searchInfo,
    getDataList,
    currentPage
})
</script>

<template>
    <div class="form px-0 " v-if="tableInfo.length || loading" style="height: calc(100% - 170px);">
        <!-- Bordered Tables -->
        <div class="my-scroll-bar" style="height:calc(100% - 50px); overflow-y: auto;">
            <table class="table table-bordered table-nowrap " v-loading="loading">
                <thead class="table-light ">
                    <tr>
                        <th scope="col" v-for="(head, index) in table_head" :key="index" style="color: #9599AD;"
                            :width="head.width">
                            <div class="d-flex align-items-center" style="height: 36px;">
                                {{ head.label }}
                                <div class="mx-2" v-if="head.sortable">
                                    <div :class="searchInfo.order_by == 'asc' ? 'sortActive' : ''" style="height: 13px;"
                                        class="cursor-pointer" @click="sort('asc')"><i
                                            class=" ri-arrow-drop-up-fill"></i></div>
                                    <span :class="searchInfo.order_by == 'desc' ? 'sortActive' : ''"
                                        class="cursor-pointer" @click="sort('desc')"><i
                                            class=" ri-arrow-drop-down-fill"></i></span>
                                </div>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(info, index) in tableInfo" :key="index" style="vertical-align: middle">
                        <td>{{
                            info.organization.company_name }}</td>
                        <td>{{ i18n.global.locale == 'en' ? info.hscode?.title_en : info.hscode?.title }}</td>
                        <td :title="i18n.global.locale == 'en' ? info.hscode?.description_en : info.hscode?.description"
                            style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;max-width: 200px;">{{
                                i18n.global.locale == 'en' ? info.hscode?.description_en : info.hscode?.description }} </td>
                        <td>{{ info.update_time ? dateFormat1(info.update_time, 'YYYY-MM-DD') : info.create_time ?
                            dateFormat1(info.create_time, 'YYYY-MM-DD') : '' }}</td>
                        <td :title="info.place_of_incorporation"
                            style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;max-width: 200px;">{{
                                info.place_of_origin.country }}{{
                                info.place_of_origin.province }}</td>
                        <td>{{ info.color }}</td>
                        <td>{{ info.inventory }}</td>
                        <td>{{ info.price_unit }}{{ info.price }}</td>
                        <td :title="info.pid"
                            style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;max-width: 200px;"> <img
                                class="cursor-pointer" :src="info.qrcodeImgUrl" v-if="info.qrcodeImgUrl"
                                style="width: 40px;" @click="showImageCode(info.qrcodeImgUrl)" /></td>
                        <td>
                            <ul class=" list-inline hstack gap-2 mb-0">
                                <li class="list-inline-item cursor" v-permit="'business-product.show'">
                                    <div class="text-primary d-inline-block" @click="handler('view', info)">
                                        <i class="fs-16 ri-eye-fill"></i>
                                    </div>
                                </li>
                                <!-- 删除 -->
                                <!-- <li class="list-inline-item" title="delete" v-permit="'business-product.delete'">
                                    <div class="d-inline-block text-danger cursor" @click="handler('delete', info)">
                                        <i class="fs-16 ri-delete-bin-5-fill"></i>
                                    </div>
                                </li> -->
                            </ul>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- 分页 -->
        <Pagination v-if="total" v-model:page="currentPage" v-model:perPage="pageSize" :pages="pageOption"
            :prePageOption="pageSizeOption" :tab_info_length="total" class="me-5" style="margin-top: 0 !important;">
        </Pagination>
    </div>
    <div v-else style="height: calc(100% - 170px);" class="d-flex align-items-center justify-content-center">
        <Empty style="margin-top: 200px;"></Empty>
    </div>
    <PreviewImg v-model:showPreviewImg="showPreviewImg" :src="activeImageSrc" :myWidth="400" v-if="showPreviewImg">
    </PreviewImg>
    <message-alert :alertInfo="alertInfo" v-if="formValidataAlert"></message-alert>
</template>
<style scoped>
.table-bordered> :not(caption)>*>* {
    border: unset;
}

.table-bordered td,
.table-bordered th {
    padding: 0.25rem 0.6rem !important;
}

.sortActive {
    color: black;
}
</style>